import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      backgroundColor: Colors.white,
    },
  },
};
